"use client"

import { getSiteUrl } from "@repo/shared"
import IconFont from "@repo/ui/iconfont"
import { useLocale, useTranslations } from "next-intl"
import Link from "next/link"
import React, { useEffect, useRef, useState } from "react"

import Style from "./index.module.scss"

type Props = {
	html: string
}

const IntroCollapse: React.FC<Props> = ({ html }) => {
	const [isExpanded, setIsExpanded] = useState(false)
	const [hasOverflow, setHasOverflow] = useState(false)
	const descRef = useRef<HTMLDivElement | null>(null)
	const locale = useLocale()
	const t = useTranslations("DetailPage.intro")
	const measureOverflow = () => {
		const el = descRef.current
		if (!el) return
		// 在折叠状态下比较可滚动高度与可见高度
		const isOverflowing = el.scrollHeight > el.clientHeight + 1
		setHasOverflow(isOverflowing)
	}

	useEffect(() => {
		// 仅在折叠状态测量，避免展开时测量将 hasOverflow 置为 false
		if (!isExpanded) {
			measureOverflow()
		}
		const onResize = () => {
			if (!isExpanded) measureOverflow()
		}
		window.addEventListener("resize", onResize)
		return () => window.removeEventListener("resize", onResize)
	}, [isExpanded, html])

	const toggleExpand = () => {
		setIsExpanded(!isExpanded)
	}

	return (
		<>
			{html && (
				<div
					ref={descRef}
					className={`${Style.desc} ${isExpanded ? Style.expanded : Style.collapsed}`}
					dangerouslySetInnerHTML={{ __html: html }}
				></div>
			)}

			<div className={Style.actionRow}>
				<Link
					href={`${getSiteUrl("www")}/${locale}/about-us#contact-us`}
					target="_blank"
					className={Style.us}
					prefetch={false}
					rel="noopener noreferrer"
				>
					{t("contactUs")}
					<IconFont
						type="icon-a-Arrow-rightjiantouyou"
						style={{
							fill: "#fff",
							fontSize: "12px",
						}}
					/>
				</Link>

				{hasOverflow && (
					<span className={Style.more} onClick={toggleExpand}>
						{isExpanded ? t("less") : t("more")}
						<IconFont
							type="icon-xialacu"
							style={{
								fill: "#d7000f",
								fontSize: "20px",
								transform: !isExpanded ? "rotate(0deg)" : "rotate(180deg)",
							}}
						/>
					</span>
				)}
			</div>
		</>
	)
}

export default IntroCollapse
